export const DEFAULT_PAGE_VIEW_EVENT = '[Amplitude] Page View';
export const DEFAULT_SESSION_START_EVENT = 'session_start';
export const DEFAULT_SESSION_END_EVENT = 'session_end';
export const DEFAULT_FORM_START_EVENT = '[Amplitude] Form Start';
export const DEFAULT_FORM_SUBMIT_EVENT = '[Amplitude] Form Submit';
export const DEFAULT_FILE_DOWNLOAD_EVENT = '[Amplitude] File Download';
